import { render, staticRenderFns } from "./wv-relationship-mapping.vue?vue&type=template&id=52e624cd&scoped=true&"
import script from "./wv-relationship-mapping.vue?vue&type=script&lang=js&"
export * from "./wv-relationship-mapping.vue?vue&type=script&lang=js&"
import style0 from "./wv-relationship-mapping.vue?vue&type=style&index=0&id=52e624cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e624cd",
  null
  
)

export default component.exports